import { db } from './firebase';
import { MANAGER_ROLE, WORKER_ROLE } from '../utils/constants';
import { Base64 } from 'js-base64';

const intersect = (o1, o2) => {

  return Object.keys(o1).filter({}.hasOwnProperty.bind(o2)).reduce((acc, key) => { acc[key] = o1[key]; return acc; }, {});

};

export const createUser = (username, email) => {
  const encodedEmail = window.btoa(email);
  db.ref(`users/${encodedEmail}`).update({
    username,
    email,
  });
};

export const getUsers = () => db.ref('users').once('value');

export const createEmptyProject = () => db.ref().child('posts').push().key;

export const initProject = (projectId, email) => {
  const encodedEmail = window.btoa(email);
  return db.ref().update({
    [`projects/${projectId}/createdOn`]: (new Date()).getTime()
  })
    .then(() => db.ref().update({
      [`projects/${projectId}/createdBy`]: encodedEmail
    }))
    .then(() => addUserToProject(projectId, email, MANAGER_ROLE));
};

export const deleteProject = (projectId, email) => db.ref().child(`projects/${projectId}`).once('value')
  .then((snapshot) => {
    snapshot.forEach((childSnapshot) => {
      childSnapshot.forEach((child) => {
        switch (child.ref.parent.key) {
          case 'cycles': {
            db.ref().child(`cycles/${child.ref.key}`).remove();
            break;
          }
          case 'targetGroups': {
            db.ref().child(`targetGroups/${child.ref.key}`).remove();
            break;
          }
          case 'useCases': {
            db.ref().child(`useCases/${child.ref.key}`).remove();
            break;
          }
          case 'members': {
            if (child.node_.value_ === 'worker') {
              db.ref().child(`users/${child.ref.key}/projects/worker/${projectId}`).remove();
              break;
            } else if (child.node_.value_ === 'co-manager') {
              db.ref().child(`users/${child.ref.key}/projects/co-manager/${projectId}`).remove();
              break;
            } else if (child.node_.value_ === 'manager') {
              db.ref().child(`users/${child.ref.key}/projects/manager/${projectId}`).remove();
            }
            break;
          }
          case 'documents': {
            db.ref().child(`documents/${child.ref.key}`).remove();
            break;
          }
          default: {
          }
        }
      });
    });
  })
  .then(() => {
    db.ref().child('tasks').orderByChild('project').equalTo(projectId).once('value')
      .then((snapshot) => {
        snapshot.forEach((child) => {
          db.ref().child(`tasks/${child.key}`).remove();
        })
      })
  })
  .then(() => {
    db.ref().child('subTasks').orderByChild('project').equalTo(projectId).once('value')
      .then((snapshot) => {
        snapshot.forEach((child) => {
          db.ref().child(`subTasks/${child.key}`).remove();
        })
      })
  }).then(() => {
    db.ref().child(`users/${window.btoa(email)}/projects/worker/${projectId}`).remove()
  }).then(() => {
    db.ref().child(`projects/${projectId}`).remove()
  })


export const updateProjectTitle = (projectId, newTitle) => {
  db.ref().update({
    [`projects/${projectId}/title`]: newTitle
  });
};

export const updateProjectDate = (projectId, field, value) => db.ref().update({
  [`projects/${projectId}/${field}`]: value
});

export const addTargetGroupToProject = (projectId, targetGroupId) => db.ref().update({
  [`projects/${projectId}/targetGroups/${targetGroupId}`]: true
});

export const createEmptyTargetGroup = () => db.ref().child('targetGroups').push().key;

export const initTargetGroup = () => {
  const targetGroupId = createEmptyTargetGroup();
  return db.ref()
    .update({
      [`targetGroups/${targetGroupId}/name`]: '',
      [`targetGroups/${targetGroupId}/description`]: '',
    })
    .then(() => targetGroupId);
};

export const saveTargetGroup = (projectId, name, description) => {
  const targetGroupId = createEmptyTargetGroup();
  return addTargetGroupToProject(projectId, targetGroupId)
    .then(() => db.ref()
      .update({
        [`targetGroups/${targetGroupId}/name`]: name,
        [`targetGroups/${targetGroupId}/description`]: description,
      })
      .then(() => targetGroupId));
};
export const saveUseCase = (projectId, name, description) => {
  const useCaseId = createEmptyUseCase();
  return addUseCaseToProject(projectId, useCaseId)
    .then(() => db.ref()
      .update({
        [`useCases/${useCaseId}/name`]: name,
        [`useCases/${useCaseId}/description`]: description,
      })
      .then(() => useCaseId));
};

export const updateTargetGroupName = (targetGroupId, name) => db.ref().update({
  [`targetGroups/${targetGroupId}/name`]: name
});

export const updateTargetGroupDescription = (targetGroupId, description) => db.ref().update({
  [`targetGroups/${targetGroupId}/description`]: description
});

export const deleteTargetGroup = (projectId, targetGroupId) => db.ref().child(`targetGroups/${targetGroupId}`).remove()
  .then(() => db.ref().child(`projects/${projectId}/targetGroups/${targetGroupId}`).remove());

export const addUserToProject = (projectId, email, role) => {
  const encodedEmail = window.btoa(email);
  return db.ref().update({
    [`projects/${projectId}/members/${encodedEmail}`]: role
  })
    .then(() => {
      if (role === WORKER_ROLE) {
        return addProjectToUser(encodedEmail, projectId, role);
      }
      return Promise.all([addProjectToUser(encodedEmail, projectId, role), addProjectToUser(encodedEmail, projectId, WORKER_ROLE)]);
    });
};

export const addProjectToUser = (userId, projectId, role) => db.ref().update({
  [`users/${userId}/projects/${role}/${projectId}`]: true
});

export const createEmptyDocument = () => db.ref().child('documents').push().key;

export const initDocument = (projectId, documentName, email) => {
  const documentId = createEmptyDocument();
  const encodedEmail = window.btoa(email);
  return db.ref().update({
    [`documents/${documentId}/name`]: documentName,
    [`documents/${documentId}/description`]: '',
    [`documents/${documentId}/uploadDate`]: (new Date()).getTime(),
    [`documents/${documentId}/user`]: encodedEmail,
    [`documents/${documentId}/project`]: projectId,

  })
    .then(() => addDocumentToProject(projectId, documentId)
      .then(() => documentId));
};

export const initPersonaDocument = (document, taskId, projectId, cycleId, subtaskId, email) => {
  const documentId = createEmptyDocument();
  const encodedEmail = window.btoa(email);
  return db.ref().update({
    [`documents/${documentId}/name`]: document.name,
    [`documents/${documentId}/description`]: '',
    [`documents/${documentId}/uploadDate`]: (new Date()).getTime(),
    [`documents/${documentId}/task`]: taskId,
    [`documents/${documentId}/project`]: projectId,
    [`documents/${documentId}/cycle`]: cycleId,
    [`documents/${documentId}/subTask`]: subtaskId,
    [`documents/${documentId}/active`]: true,
    [`documents/${documentId}/user`]: encodedEmail
  }).then(() => documentId);
};

export const removeDocumentFromSubTask = (subTaskId, documentId) => {
  return db.ref().update({
    [`subTasks/${subTaskId}/docUrl`]: null,
    [`subTasks/${subTaskId}/finished`]: false,
    [`subTasks/${subTaskId}/docName`]: null,
    [`documents/${documentId}/active`]: false,
    [`subTasks/${subTaskId}/finishedDate`]: null,
  })
}

export const updatePersonaDocumentsTags = (documentId, array, extension) => {
  array.map((val) => {
    if (val !== '' && val !== undefined && !val.includes('/')) {
      db.ref().update({
        [`documents/${documentId}/tags/${val}`]: true,
      });
    }
    if (val !== '' && val !== undefined && val.includes('/')) {
      db.ref().update({
        [`documents/${documentId}/tags/${val.replace(/\//g, ' - ')}`]: true,
      });
    }
  })
  db.ref().update({
    [`documents/${documentId}/tags/${extension}`]: true
  });
};

export const updateDocumentsTags = (documentId, project, extension) => {
  if (project !== '' && project !== undefined) {
    db.ref().update({
      [`documents/${documentId}/tags/${project}`]: true,
    });
  }
  db.ref().update({
    [`documents/${documentId}/tags/${extension}`]: true
  });
}

export const addDocumentToProject = (projectId, documentId) => db.ref().update({
  [`projects/${projectId}/documents/${documentId}`]: true
});

export const updateDocumentTags = (documentId, tag) => db.ref().update({
  [`documents/${documentId}/tags/${tag}`]: true
});


export const updateDocumentDescription = (documentId, description) => db.ref().update({
  [`documents/${documentId}/description`]: description
});

export const deleteDocument = (projectId, documentId) => db.ref().child(`documents/${documentId}`).remove()
  .then(() => db.ref().child(`projects/${projectId}/documents/${documentId}`).remove());

export const removeTag = (documentId, tag) => db.ref().update({ [`documents/${documentId}/tags/${tag}`]: null });

export const createEmptyUseCase = () => db.ref().child('useCases').push().key;

export const initUseCase = () => {
  const useCaseId = createEmptyUseCase();
  return db.ref()
    .update({
      [`useCases/${useCaseId}/name`]: '',
      [`useCases/${useCaseId}/description`]: '',
    })
    .then(() => useCaseId);
};

export const updateUseCaseName = (useCaseId, name) => db.ref().update({
  [`useCases/${useCaseId}/name`]: name
});

export const updateUseCaseDescription = (useCaseId, description) => db.ref().update({
  [`useCases/${useCaseId}/description`]: description
});

export const addUseCaseToProject = (projectId, useCaseId) => db.ref().update({
  [`projects/${projectId}/useCases/${useCaseId}`]: true
});

export const deleteUseCase = (projectId, useCaseId) => db.ref().child(`useCases/${useCaseId}`).remove()
  .then(() => db.ref().child(`projects/${projectId}/useCases/${useCaseId}`).remove());

export const deleteMember = (projectId, userId, role) => db.ref().child(`projects/${projectId}/members/${userId}`).remove()
  .then(() => db.ref().child(`users/${userId}/projects/${role}/${projectId}`).remove())
  .then(() => removeAssignedTasksForDeletedUser(userId));

export const createEmptyCycle = () => db.ref().child('cycles').push().key;

export const initCycle = (projectId, email) => {
  const encodedEmail = window.btoa(email);
  const cycleId = createEmptyCycle();
  return db.ref()
    .update({
      [`cycles/${cycleId}/title`]: '',
      [`cycles/${cycleId}/project`]: projectId,
      [`cycles/${cycleId}/createdBy`]: encodedEmail,
      [`cycles/${cycleId}/index`]: 0,
      [`projects/${projectId}/cycles/${cycleId}/index`]: 0
    })
    .then(() => createPredefinedTasks(projectId, cycleId, email))
    .then(() => cycleId);
};

export const addCycleToProject = (projectId, cycleId) => db.ref().update({
  [`projects/${projectId}/cycles/${cycleId}`]: true
});

export const updateCycleTitle = (cycleId, title) => db.ref().update({
  [`cycles/${cycleId}/title`]: title
});

export const updateCycleDueDate = (cycleId, phase, dueDate) => db.ref().update({
  [`cycles/${cycleId}/dueDates/${phase}`]: dueDate
});

export const updateTaskDueDate = (cycleId, phase, taskId, dueDate) => db.ref().update({
  [`cycles/${cycleId}/tasks/${phase}/${taskId}/dueDate`]: dueDate,
  [`tasks/${taskId}/dueDate`]: dueDate
});

export const createEmptyTask = () => db.ref().child('tasks').push().key;

export const initTask = (projectId, cycleId, email, name = 'n/a') => {
  const encodedEmail = window.btoa(email);
  const taskId = createEmptyTask();
  return db.ref()
    .update({
      [`tasks/${taskId}/project`]: projectId,
      [`tasks/${taskId}/cycle`]: cycleId,
      [`tasks/${taskId}/manager`]: encodedEmail,
      [`tasks/${taskId}/name`]: name,
      // [`tasks/${taskId}/document`]: ,
      [`tasks/${taskId}/active`]: true
    })
    .then(() => initSubTask(taskId, cycleId, projectId, name))
    .then(() => taskId);
};

export const addTaskToCycle = (cycleId, taskId, type) => db.ref().update({
  [`cycles/${cycleId}/tasks/${type}/${taskId}/active`]: true
});

export const deactivateTaskInCycle = (cycleId, taskId, type) => db.ref().update({
  [`cycles/${cycleId}/tasks/${type}/${taskId}/active`]: false
});

export const updateTaskName = (taskId, name) => db.ref().update({
  [`tasks/${taskId}/name`]: name
});

export const updateTaskDescription = (taskId, description) => db.ref().update({
  [`tasks/${taskId}/description`]: description
});

export const updateTaskActive = (taskId, active) => db.ref().update({
  [`tasks/${taskId}/active`]: active
});

export const createPredefinedTasks = (projectId, cycleId, email) => {
  const learn = ['Mitbewerberanalyse', 'Trends', 'Kundenbefragung', 'IST Customer Journey', 'Touchpoints'];
  const define = ['Personas', 'Beduerfnisse', 'Use Cases', 'SOLL Customer Journey', 'Anforderungskonzept', 'Inhaltskonzept'];
  const build = ['Workflows/Interaktionen', 'Wireframes', 'User Testing WF', 'Design/Layout', 'User Testing Design'];
  const test = ['Prototyp', 'User Testing Prototyp', 'Ergebnisse'];
  return Promise.all(learn.map(task => initTask(projectId, cycleId, email, task)
    .then(taskId => addTaskToCycle(cycleId, taskId, 'learn'))))
    .then(() => Promise.all(define.map(task => initTask(projectId, cycleId, email, task)
      .then(taskId => addTaskToCycle(cycleId, taskId, 'define')))))
    .then(() => Promise.all(build.map(task => initTask(projectId, cycleId, email, task)
      .then(taskId => addTaskToCycle(cycleId, taskId, 'build')))))
    .then(() => Promise.all(test.map(task => initTask(projectId, cycleId, email, task)
      .then(taskId => addTaskToCycle(cycleId, taskId, 'test')))));
};

export const createEmptySubTask = () => db.ref().child('subTasks').push().key;

export const initSubTask = (taskId, cycleId, projectId, name = 'n/a') => {
  const subTaskId = createEmptySubTask();
  return db.ref()
    .update({
      [`subTasks/${subTaskId}/task`]: taskId,
      [`subTasks/${subTaskId}/project`]: projectId,
      [`subTasks/${subTaskId}/cycle`]: cycleId,
      [`subTasks/${subTaskId}/name`]: name,
      [`subTasks/${subTaskId}/createdOn`]: (new Date()).getTime(),
      [`tasks/${taskId}/subTasks/${subTaskId}`]: true
    })
    .then(() => subTaskId);
};

export const createEmptyUserNotification = userId => db.ref().child(`notifications/${userId}/`).push().key;

export const assignWithoutNot = (subTaskId, userId, taskName) => {
  db.ref()
    .update({
      [`subTasks/${subTaskId}/assignedTo`]: userId,
    })
}

export const assignSubTaskToMember = (subTaskId, userId, taskName) => {
  db.ref()
    .update({
      [`subTasks/${subTaskId}/assignedTo`]: userId,
    }).then(() => {
      const notId = createEmptyUserNotification(userId);
      db.ref().update({
        [`notifications/${userId}/${notId}/title`]: 'Task ',
        [`notifications/${userId}/${notId}/message`]: taskName + ' zugeteilt',
        [`notifications/${userId}/${notId}/read`]: false,
        [`notifications/${userId}/${notId}/subTask`]: subTaskId,
      });
    });
};

export const getLogoImg = () => {
  return db.ref().child(`logo`).limitToLast(1).once('value')
    .then((snapshot) => {
      let img = snapshot.val()
      return Object.values(img)[0];
    })

}

export const getNotifications = (email) => {
  const encodedEmail = window.btoa(email);
  const promiseArray = [];
  return db.ref().child(`notifications/${encodedEmail}`).once('value')
    .then((snapshot) => {
      snapshot.forEach((child) => {
        promiseArray.push(db.ref().child(`subTasks/${child.val().subTask}`).once('value')
          .then((subTask) => {
            if (subTask.val()) {
              return db.ref().child(`tasks/${subTask.val().task}`).once('value')
                .then((task) => {
                  if (task.val()) {
                    return db.ref().child(`cycles/${task.val().cycle}`).once('value')
                      .then(name => {
                        if (name.val()) {
                          return db.ref().child(`projects/${task.val().project}`).once('value')
                            .then(pro => pro.val() && ({
                              notId: child.key,
                              notification: child.val(),
                              subTaskId: subTask.key,
                              subTask: subTask.val(),
                              task: task.val(),
                              cycles: name.val(),
                              project: pro.val()
                            }));
                        }
                      });
                  }
                });
            }
          }));
      });
      return Promise.all(promiseArray);
    });
}

export const readNotification = (email, notId) => {
  const encodedEmail = window.btoa(email);
  return db.ref().update({
    [`notifications/${encodedEmail}/${notId}/read`]: true,
  });
};


export const updateSubTask = (subTaskId, field, newValue) => db.ref()
  .update({
    [`subTasks/${subTaskId}/${field}`]: newValue || '',
  });


export const deleteSubTask = subTaskId => db.ref(`subTasks/${subTaskId}`)
  .once('value')
  .then((snapshot) => {
    const taskId = snapshot.val() && snapshot.val().task;
    return db.ref().update({
      [`subTasks/${subTaskId}`]: null,
      [`tasks/${taskId}/subTasks/${subTaskId}`]: null
    });
  });


export const getTasks = (projectId, email) => {
  const encodedEmail = window.btoa(email);
  return db.ref().child('subTasks').orderByChild('assignedTo').equalTo(encodedEmail)
    .once('value')
    .then((snapshot) => {
      const promiseArray = [];
      snapshot.forEach((child) => {
        promiseArray.push(db.ref().child(`tasks/${child.val().task}`).once('value')
          .then((task) => {
            if (task && task.val() && task.val().project === projectId) {
              return db.ref().child(`cycles/${task.val().cycle}`).once('value')
                .then(name => ({
                  subTaskId: child.key,
                  subTask: child.val(),
                  task: task.val(),
                  cycles: name.val()
                }));
            }
          }));
      });
      return Promise.all(promiseArray);
    });
};


export const getTask = (subTaskId) => {
  return db.ref('subTasks').orderByKey().equalTo(subTaskId)
    .once('value')
    .then((snapshot) => {
      return Object.assign({}, Object.values(snapshot.val()));
    });
};

export const getTaskDescription = (taskId) => {
  return db.ref('tasks').orderByKey().equalTo(taskId)
    .once('value')
    .then((snapshot) => {
      return Object.assign({}, Object.values(snapshot.val()));
    });
};

export const getWorkerDocument = (subTask) => {
  return db.ref().child('documents').orderByChild('subTask').equalTo(subTask).limitToLast(1)
    .once('value')
    .then((snapshot) => {
      const document = snapshot.val();
      return document;
    })
}

export const updateTasksOrder = (cycleId, phase, orderedTasks) => {
  const updates = Object.keys(orderedTasks).reduce((acc, taskId) => {
    acc[`cycles/${cycleId}/tasks/${phase}/${taskId}/index`] = orderedTasks[taskId].index;
    return acc;
  }, {});
  return db.ref().update(updates);
};


export const copyTask = (projectId, cycleId, taskId, email) => {
  const newTaskId = createEmptyTask();
  let encodedEmail = '';
  if (!email) {
    return Promise.reject(new Error('Email not defined'));
  }
  encodedEmail = window.btoa(email);
  let taskData;
  return db.ref(`tasks/${taskId}`)
    .once('value')
    .then((snapshot) => {
      taskData = snapshot.val();
      return initSubTask(newTaskId, cycleId, projectId, taskData.name);
    })
    .then((subTaskId) => {
      taskData.subTasks = { [subTaskId]: true };
      taskData.project = projectId;
      taskData.cycle = cycleId;
      taskData.manager = encodedEmail;
      taskData.createdOn = (new Date()).getTime();
      taskData.parentTask = taskId;
      taskData.active = true;
      return db.ref(`tasks/${newTaskId}`).set(taskData);
    })
    .then(() => newTaskId);
};

export const copyCycle = (projectId, cycleId, index, email) => {
  const newCycleId = createEmptyCycle();
  let cycleData;
  const newTasks = {
    learn: {},
    define: {},
    build: {},
    test: {}
  };
  return db.ref(`cycles/${cycleId}`)
    .once('value')
    .then((snapshot) => {
      cycleData = snapshot.val();
      return Promise.all(Object.keys(cycleData.tasks.learn).map(taskId => copyTask(projectId, newCycleId, taskId, email)));
    })
    .then((tasks) => {
      newTasks.learn = tasks.reduce((acc, taskId) => {
        acc[taskId] = { active: true };
        return acc;
      }, {});
      return Promise.all(Object.keys(cycleData.tasks.build).map(taskId => copyTask(projectId, newCycleId, taskId, email)));
    })
    .then((tasks) => {
      newTasks.build = tasks.reduce((acc, taskId) => {
        acc[taskId] = { active: true };
        return acc;
      }, {});
      return Promise.all(Object.keys(cycleData.tasks.define).map(taskId => copyTask(projectId, newCycleId, taskId, email)));
    })
    .then((tasks) => {
      newTasks.define = tasks.reduce((acc, taskId) => {
        acc[taskId] = { active: true };
        return acc;
      }, {});
      return Promise.all(Object.keys(cycleData.tasks.test).map(taskId => copyTask(projectId, newCycleId, taskId, email)));
    })
    .then((tasks) => {
      newTasks.test = tasks.reduce((acc, taskId) => {
        acc[taskId] = { active: true };
        return acc;
      }, {});
      cycleData.title = '';
      cycleData.tasks = newTasks;
      cycleData.previousCycle = cycleId;
      cycleData.index += 1;
      return db.ref(`cycles/${newCycleId}`).set(cycleData);
    })
    .then(() => db.ref().update({ [`projects/${projectId}/cycles/${newCycleId}/index`]: index }))
    .then(() => newCycleId);
};

export const removeTaskFromCycle = (cycleId, phase, taskId) => {
  return db.ref().update({ [`cycles/${cycleId}/tasks/${phase}/${taskId}`]: null })
    .then(() => {
      db.ref().child('subTasks').orderByChild('task').equalTo(taskId).once('value')
        .then((snapshot) => {
          snapshot.forEach((child) => {
            db.ref().child(`subTasks/${child.key}`).remove();
          })
        })
    }).then(() => {
      db.ref().update({ [`tasks/${taskId}`]: null })
    })
}

export const getNumberOfActiveTasksInProject = projectId => db.ref('tasks')
  .orderByChild('project')
  .equalTo(projectId)
  .once('value')
  .then((snapshot) => {
    const tasks = snapshot.val() || {};
    return Promise.all(
      Object.keys(tasks)
        .filter(taskId => tasks[taskId].active === true)
        .map(taskId => db.ref('subTasks')
          .orderByChild('task')
          .equalTo(taskId)
          .once('value')
          .then((subTasksSnapshot) => {
            const subTasks = subTasksSnapshot.val() || {};
            return Object.keys(subTasks).filter(subTaskId => subTasks[subTaskId].assignedTo && !subTasks[subTaskId].finished).length;
          }))
    )
      .then((assignedNotFinishedTasks) => assignedNotFinishedTasks.reduce((acc, numberOfTask) => numberOfTask ? acc + numberOfTask : acc, 0));
  });

export const getAllProjects = () => {
  return db.ref('projects')
    .orderByChild('title')
    .once('value')
    .then((snapshot) => {
      const projects = snapshot.val() || {};
      const projectTitles = Object.keys(projects).map(projectId => ({ label: projects[projectId].title, value: projectId }));
      return projectTitles;
    })
};

export const getAllDocuments = () => {
  return db.ref('documents')
    .orderByChild('name')
    .once('value')
    .then((snapshot) => {
      const documents = snapshot.val() || {};
      return documents;
    })
}

export const getAllCycles = (projectId = null) => {
  if (projectId) {
    return db.ref('cycles')
      .orderByChild('project')
      .equalTo(projectId)
      .once('value')
      .then((snapshot1) => {
        const cycles = snapshot1.val() || {};
        const cycleTitles = Object.keys(cycles).map(cycleId => ({ label: cycles[cycleId].title, value: cycleId }));
        return cycleTitles;
      });
  }
  return db.ref('cycles')
    .orderByChild('title')
    .once('value')
    .then((snapshot) => {
      const cycles = snapshot.val() || {};
      const cycleTitles = Object.keys(cycles).map(cycleId => ({ label: cycles[cycleId].title, value: cycleId }));
      return cycleTitles;
    });
};
export const getAllTasks = (cycleId = null) => {
  if (cycleId) {
    return db.ref('tasks')
      .orderByChild('cycle')
      .equalTo(cycleId)
      .once('value')
      .then((snapshot) => {
        const tasks = snapshot.val() || {};
        const taskTitles = Object.keys(tasks).map(taskId => ({ label: tasks[taskId].name, value: taskId }));
        return taskTitles;
      });
  }
  return db.ref('tasks')
    .orderByChild('title')
    .once('value')
    .then((snapshot) => {
      const tasks = snapshot.val() || {};
      const taskTitles = Object.keys(tasks).map(taskId => ({ label: tasks[taskId].name, value: taskId }));
      return taskTitles;
    });
};

export const getDocuments = filters => {
  const { projectId, cycleId, taskId, userId, fileType } = filters;
  const promises = [];
  if (projectId) {
    promises.push(
      db.ref('documents')
        .orderByChild('project')
        .equalTo(projectId)
        .once('value')
        .then(snapshot => {
          return snapshot.val() || {};
        })
    );
  }
  if (cycleId) {
    promises.push(
      db.ref('documents')
        .orderByChild('cycle')
        .equalTo(cycleId)
        .once('value')
        .then(snapshot => {
          return snapshot.val() || {};
        })
    );
  }
  if (taskId) {
    promises.push(
      db.ref('documents')
        .orderByChild('task')
        .equalTo(taskId)
        .once('value')
        .then(snapshot => {
          return snapshot.val() || {};
        })
    );
  }
  if (userId) {
    promises.push(
      db.ref('documents')
        .orderByChild('user')
        .equalTo(userId)
        .once('value')
        .then(snapshot => {
          console.log(snapshot.val());
          return snapshot.val() || {};
        })
    );
  }
  if (promises.length > 0) {
    return Promise.all(promises)
      .then(documents => {
        const intersectedKeys = documents.reduce((acc, doc, i) => (i === 0) ? doc : intersect(acc, doc), {});
        if (fileType) {
          const docs = {};
          Object.keys(intersectedKeys).map((item) => {
            intersectedKeys[item].name.split('.').pop().toLowerCase() === fileType && Object.assign(docs, { [item]: intersectedKeys[item] })
          })
          return docs;
        }
        return intersectedKeys;
      });
  }
  return db.ref('documents')
    .orderByChild('uploadDate')
    .once('value')
    .then(snapshot => {
      const snap = snapshot.val() || {}
      if (fileType) {
        const docs = {};
        Object.keys(snap).map((item) => {
          snap[item].name.split('.').pop().toLowerCase() === fileType && Object.assign(docs, { [item]: snap[item] })
        })
        return docs;
      }
      return snap;
    });
};

export const getAuthors = () => {
  return db.ref('users')
    .once('value')
    .then(snapshot => {
      const users = snapshot.val() || {};
      const emails = Object.keys(users).map(userId => ({ value: userId, label: Base64.decode(userId) }));
      console.log(emails);
      return emails;
    });
};

export const removeAssignedTasksForDeletedUser = (userId) => {
  return db.ref('subTasks')
    .orderByChild('assignedTo')
    .equalTo(userId)
    .once('value')
    .then(snapshot => snapshot.val() || {})
    .then(subTasks => {
      const updates = Object.keys(subTasks)
        .filter(subTaskId => !subTasks[subTaskId].finished)
        .map(subTaskId => ({ [`subTasks/${subTaskId}/assignedTo`]: null }))
        .reduce((result, update) => Object.assign(result, update), {});
      return db.ref().update(updates);
    });
};


export const getUsersManagerProjects = email => {
  return Promise.all([
    db.ref(`users/${Base64.encode(email)}/projects/${MANAGER_ROLE}`)
      .once('value')
      .then(snapshot => snapshot.val() || {}),
  ])
    .then(projects => {
      console.log('projects', projects[0]);
      return projects[0];
    });
};



// WEBPACK FOOTER //
// ./src/firebase/db.js